export default __webpack_public_path__ + "static/media/ossscreen10.60e2446d.png";